<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="transition-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="m16 3 4 4-4 4" />
    <path d="M20 7H4" />
    <path d="m8 21-4-4 4-4" />
    <path d="M4 17h16" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#0088cc',
  },
})
</script>

<style scoped>
.transition-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #0088cc);
}

.transition-icon:hover {
  opacity: 0.8;
}
</style>

<style>
/* Make icon white when inside buttons */
a.btn-link .transition-icon,
a.btn-sm .transition-icon,
button.btn-sm .transition-icon,
button.btn-primary .transition-icon {
  color: white !important;
}
</style>
